import { Button } from 'antd';
import { useState } from 'react';
import TotalCashToCloseDetailsModal from './TotalCashToCloseDetailsModal';

const TotalCashToCloseDetails = () => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const toggleIsOpenModal = () => setIsOpenModal(prev => !prev)

  return (
    <div>
      <Button
        type="default"
        onClick={toggleIsOpenModal}
      >
        Details
      </Button>
      {isOpenModal && (
        <TotalCashToCloseDetailsModal isOpen={isOpenModal} onCancel={toggleIsOpenModal} />
      )}
    </div>
  )
}

export default TotalCashToCloseDetails;
